import { z } from 'zod';
import { scanResultSchema, securityIssueSchema } from '../scans';
import { decisionPlanSchema } from './decisions';
// v2 scan ingest (KIR-3071). Same payload as v1 POST /api/scans
// (`ScanRequestBody`, previously uncontracted); response adds a `DecisionPlan`.
// Backend reuses v1 `createScan` then layers the plan -- v1 behavior unchanged.
export const scanV2RequestSchema = z.object({
    filePath: z.string(),
    fullPath: z.string().optional(),
    content: z.string(),
    fileType: z.string(),
    timestamp: z.number().optional(),
    clientVersion: z.string(),
    extraData: z.record(z.string(), z.unknown()).optional(),
    isDatabaseContent: z.boolean().optional(),
    databaseType: z.string().optional(),
    clientDetectedIssues: z.array(securityIssueSchema).optional(),
    fileRoot: z.string().optional(),
    relativePath: z.string().optional(),
    // Git identity for project resolution (KIR-3356). Mirrors the v1 scan body;
    // Zod strips unknown keys, so these MUST be declared here or the v2 ingest
    // path silently drops them and every v2 scan degrades to folder/machine
    // identity (never collapsing worktrees of one repo into a shared project).
    gitOriginUrl: z.string().nullable().optional(),
    repoRoot: z.string().nullable().optional(),
});
// v1 scan result plus the decision plan the agent should enforce.
export const scanV2ResponseSchema = scanResultSchema.extend({
    plan: decisionPlanSchema,
});
//# sourceMappingURL=scans.js.map